"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var joinParticipationRoles = function (participationRoles) {
    if (participationRoles === void 0) { participationRoles = []; }
    return participationRoles
        .map(function (participationRole) { return participationRole.name; })
        .join(", ");
};
var ParticipationInfo = function (_a) {
    var _b, _c, _d;
    var seasonParticipant = _a.seasonParticipant;
    var teamName = ((_b = seasonParticipant.team) === null || _b === void 0 ? void 0 : _b.name) || "No Team";
    var season = (seasonParticipant.season); // TODO: give this the correct type so that {season?.program?.name} works
    var registration = seasonParticipant.registration;
    var participantRoles = joinParticipationRoles(seasonParticipant.participationRoles);
    var participantRolesDisplay = participantRoles ? participantRoles : "-";
    return (React.createElement("div", { className: "Grid Grid--fit Grid--withGutter" },
        React.createElement("div", { className: "Grid-cell" },
            React.createElement("div", { className: "u-pad" },
                React.createElement("div", null,
                    (season === null || season === void 0 ? void 0 : season.isArchived) ? React.createElement("span", { className: "u-fontSizeLg u-colorGrey" }, "\u2022 ") : React.createElement("span", { className: "u-fontSizeLg u-colorPositive" }, "\u2022 "), (_c = season === null || season === void 0 ? void 0 : season.program) === null || _c === void 0 ? void 0 :
                    _c.name),
                React.createElement("div", { className: "u-colorGrey" }, season === null || season === void 0 ? void 0 : season.name))),
        React.createElement("div", { className: "Grid-cell" },
            React.createElement("div", { className: "u-pad" },
                React.createElement("div", null, teamName),
                React.createElement("div", { className: "u-colorGrey" }, (_d = seasonParticipant.division) === null || _d === void 0 ? void 0 : _d.name))),
        React.createElement("div", { className: "Grid-cell" },
            React.createElement("p", { className: "u-pad" }, participantRolesDisplay)),
        React.createElement("div", { className: "Grid-cell" },
            React.createElement("p", { className: "u-pad" }),
            registration.registrationFormName ? React.createElement("a", { href: "" + registration.registrationUrl, target: "_blank" }, registration.registrationFormName) : "-")));
};
exports.default = ParticipationInfo;
//# sourceMappingURL=participation-info.js.map